// extracted by mini-css-extract-plugin
export var desktopNavBar = "ck_jq";